import { AuthState } from "./types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const urlParams = new URLSearchParams(window.location.search);
const token = urlParams.get("token") || localStorage["token"] || "";
const signUpToken =
  urlParams.get("signUpToken") || localStorage["signUpToken"] || "";

if (token || signUpToken) {
  const currentPath = window.location.pathname;
  if (currentPath != "/integration/e-conomic/connect") {
    // Remove the token from the URL
    window.history.replaceState({}, document.title, "/");
    localStorage["token"] = token;
    localStorage["signUpToken"] = signUpToken;
  }
}

const initialState: AuthState = {
  isLoggedIn: false,
  loginToken: "",
  anonymousSession: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    login(state: AuthState, action: PayloadAction<string>) {
      state.isLoggedIn = true;
      state.loginToken = action.payload;
      state.anonymousSession = null;
      localStorage["signUpToken"] = "";
    },
    logout(state: AuthState) {
      state.isLoggedIn = false;
      state.loginToken = "";
      localStorage["token"] = "";
      localStorage["signUpToken"] = "";
      localStorage.removeItem("welcome_conversation_identifier");
      state.anonymousSession = null;
    },
    loginAsAnonymousUser(state: AuthState) {
      state.anonymousSession = {
        signUpState: null,
      };
    },
    updateSignUpState(state: AuthState, action: PayloadAction<any>) {
      state.anonymousSession = {
        ...state.anonymousSession,
        signUpState: {
          ...state.anonymousSession?.signUpState,
          ...action.payload,
        },
      };
    },
  },
});

export default authSlice.reducer;
export const { login, logout, loginAsAnonymousUser, updateSignUpState } =
  authSlice.actions;
